import { render, staticRenderFns } from "./RentalObjectNotifications.vue?vue&type=template&id=04ba4644&scoped=true&"
import script from "./RentalObjectNotifications.vue?vue&type=script&lang=js&"
export * from "./RentalObjectNotifications.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectNotifications.vue?vue&type=style&index=0&id=04ba4644&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba4644",
  null
  
)

export default component.exports